export default __webpack_public_path__ + "static/media/reportIcon.029bdaa9.svg";